import { For } from 'solid-js';
import { registrationMarks, MARK_STROKE_MM } from '../core/marks';

export function RegistrationMarks() {
  const marks = registrationMarks();
  return (
    <g class="registration-marks" stroke="#000" stroke-width={MARK_STROKE_MM} fill="none">
      <For each={marks}>
        {m => (
          <g transform={`translate(${m.cx}, ${m.cy})`}>
            <circle r={m.r} />
            <line x1={-m.r * 1.4} y1={0} x2={m.r * 1.4} y2={0} />
            <line x1={0} y1={-m.r * 1.4} x2={0} y2={m.r * 1.4} />
          </g>
        )}
      </For>
    </g>
  );
}
